/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type GLSyncStatus = "FAILED" | "NOT_APPLICABLE" | "PENDING" | "SYNCED";
export type JournalEntryStatus = "DRAFT" | "POSTED" | "VOIDED";
export type JournalSourceType = "INVENTORY_ADJUSTMENT" | "INVOICE" | "JOB" | "MANUAL" | "PAYMENT" | "SHIPMENT";
import type { FragmentReference } from "relay-runtime";
declare export opaque type JournalEntriesTable_journalEntryEdges$ref: FragmentReference;
declare export opaque type JournalEntriesTable_journalEntryEdges$fragmentType: JournalEntriesTable_journalEntryEdges$ref;
export type JournalEntriesTable_journalEntryEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +entryNumber: string,
    +entryDate: any,
    +memo: ?string,
    +sourceType: JournalSourceType,
    +status: JournalEntryStatus,
    +syncStatus: GLSyncStatus,
    +postedAt: ?any,
    +voidedAt: ?any,
    +totalDebit: number,
    +totalCredit: number,
    +createdByUser: ?{|
      +id: string,
      +firstName: string,
      +lastName: string,
    |},
    +createdAt: any,
  |},
  +$refType: JournalEntriesTable_journalEntryEdges$ref,
|}>;
export type JournalEntriesTable_journalEntryEdges$data = JournalEntriesTable_journalEntryEdges;
export type JournalEntriesTable_journalEntryEdges$key = {
  +$data?: JournalEntriesTable_journalEntryEdges$data,
  +$fragmentRefs: JournalEntriesTable_journalEntryEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "JournalEntriesTable_journalEntryEdges",
  "type": "JournalEntryEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "JournalEntry",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "entryNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "entryDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "memo",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sourceType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "syncStatus",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "postedAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "voidedAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalDebit",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCredit",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "createdByUser",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "firstName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "lastName",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fba5ba9e6cfdb3f9db7a3c855b171c6d';
module.exports = node;
